export default __webpack_public_path__ + "static/media/affirm-logo.24d728d8.svg";